"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRIAL = exports.TALK_TO_SALES = exports.BUY_TOUCHLESS = void 0;
var BUY_TOUCHLESS = 'buyTouchless';
exports.BUY_TOUCHLESS = BUY_TOUCHLESS;
var TALK_TO_SALES = 'talkToSales';
exports.TALK_TO_SALES = TALK_TO_SALES;
var TRIAL = 'trial';
exports.TRIAL = TRIAL;